import React, { useCallback } from 'react';
import classnames from 'classnames';

import { ReactComponent as ChevronDownSVG } from '../../../../assets/icons/chevron-down.svg';

import './Select.scss';

export interface SelectProps {
  className?: string;
  disabled?: boolean;
  options?;
  notSelectedOption?;
  value?;
  onChange?;
}

const Select = ({
  className,
  disabled,
  options,
  notSelectedOption,
  value,
  onChange,
}: SelectProps) => {
  const handleChange = useCallback(
    ({ target: { value } }) => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <div className={classnames('select__container', className)}>
      <select
        className="select"
        disabled={disabled}
        value={value}
        onChange={handleChange}
      >
        {notSelectedOption && (
          <option
            disabled={true}
            value={notSelectedOption.value}
            className="select__option"
          >
            {notSelectedOption.label}
          </option>
        )}
        {options.map(({ label, value }) => (
          <option key={value} className="select__option" value={value}>
            {label}
          </option>
        ))}
      </select>
      <ChevronDownSVG className="select__chevron" />
    </div>
  );
};

export default Select;
